<template>
  <div
    class="gift-card"
    :class="{ active, disabled: !gift.stock, discount: discount && discount.amount }"
    @click="$emit('click')"
  >
    <div class="gift-card__header">
      <span class="price">{{ price }}</span>
      <span class="currency">{{ currency }}</span>
    </div>
    <div class="gift-card__content">
      <div class="gift-card__body">
        <span>{{ gift.quantity }}</span>
        <Icon class="gift-card__icon" name="/base/robux.svg" />
      </div>
      <div v-if="discountPercent" class="gift-card__discount">
        <span>
          {{ priceDiscount }}
        </span>
        {{ currency }}
      </div>
    </div>
  </div>
</template>

<script>
import './giftCard.scss'
import Icon from '@/components/Base/Icon/Icon.vue'

export default {
  name: 'GiftCard',
  components: { Icon },
  props: {
    gift: {
      type: Object,
      require: true,
      default: () => {}
    },
    active: {
      type: Boolean,
      default: false
    },
    discount: {
      type: Object,
      default: () => {}
    },
    // Валюта товара, если она не совпадает с валютой сайта (паки — только ₽).
    currencyCode: {
      type: String,
      default: ''
    }
  },
  computed: {
    activeCurrency() {
      return this.currencyCode || this.$store.state.currency
    },
    price() {
      return this.gift.price[this.activeCurrency]
    },
    priceDiscount() {
      return this.discount?.amount[this.activeCurrency]
    },
    discountPercent() {
      return this.discount?.percent
    },
    currency() {
      const currency = {
        rub: 'руб.',
        usd: '$',
        eur: '€'
      }
      return currency[this.activeCurrency]
    }
  }
}
</script>
